var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.departmentDialogVisible,
            title: "Danh sách phòng ban",
            width: "500px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            "custom-class": "sk-dialog",
            top: "30vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.departmentDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "sk-dialog-content" }, [
            _c("div", { staticClass: "sk-panel" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-s-home" }),
                ]),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Danh sách phòng ban"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v("Các phòng ban mà nhân viên này đang thuộc về."),
                  ]),
                ]),
              ]),
              _vm.selectedDepartmentList.length
                ? _c(
                    "div",
                    _vm._l(_vm.selectedDepartmentList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            padding: "4px 0",
                            "border-bottom": "1px solid #f1f5f9",
                            "font-size": "14px",
                            color: "#334155",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-arrow-right",
                            staticStyle: {
                              color: "#78a5e7",
                              "margin-right": "6px",
                            },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(item.department.departmentName) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "sk-note" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [
                      _vm._v(
                        "Nhân viên này chưa được phân công phòng ban nào."
                      ),
                    ]),
                  ]),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "sk-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { type: "danger" },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v("Đóng")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }